<ng-template #content let-customer="customer">
  <ng-container *ngIf="usePersonalDataForm">
    <h1 class="ibk-title">Datos personales</h1>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Fecha de nacimiento</label>
        <ibk-input icon="event" class="field">
          <input
            readonly
            #endDate
            class="field"
            formControlName="birthday"
            [disabled]="form.get('birthday')?.disabled || false"
            appDatePickerControl
          />
          <ibk-date-picker *ngIf="endDate" [el]="endDate" [config]="ibkConfig"></ibk-date-picker>
        </ibk-input>
      </ibk-input-group>
      <ibk-input-group>
        <label>Sexo</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="gender">
          <ibk-select-option
            *ngFor="let option of paramsService.params$('gender') | async"
            [value]="option.value"
            [label]="option.label"
          ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
    </div>

    <div class="ba-field-group">
      <ibk-input-group>
        <label>Estado civil</label>
        <ibk-select class="field" dsRxForm="selectChange" formControlName="maritalStatus">
          <ibk-select-option
            *ngFor="let option of paramsService.params$('maritalStatus') | async"
            [value]="option.value"
            [label]="option.label"
          ></ibk-select-option>
        </ibk-select>
      </ibk-input-group>
      <span></span>
    </div>
  </ng-container>

  <div class="ba-field-group" formGroupName="personalData">
    <ibk-input>
      <input type="checkbox" formControlName="isPEP" (change)="chkPep($event)"/>
      Soy una persona políticamente expuesta (PEP).
    </ibk-input>
  </div>

  <ng-container *ngIf="form.get('pepLegalRepresentative')" formGroupName="pepLegalRepresentative">
    <ba-pep-partners-list-form></ba-pep-partners-list-form>
  </ng-container>

  <h1 class="ibk-title">Datos de contacto</h1>

  <div class="ba-field-group">
    <ibk-input-group>
      <label>Número de celular</label>
      <ibk-input class="field" char-filter="[0-9]">
        <input class="field" maxlength="9" formControlName="phoneNumber" />
      </ibk-input>
    </ibk-input-group>
    <ibk-input-group>
      <label>Operador</label>
      <ibk-select class="field" dsRxForm="selectChange" formControlName="phoneCarrier">
        <ibk-select-option
          *ngFor="let option of paramsService.params$('mobileOperator') | async"
          [value]="option.value"
          [label]="option.label"
        ></ibk-select-option>
      </ibk-select>
    </ibk-input-group>
  </div>
  <p class="error-message" *ngIf="form.get('phoneNumber')?.errors?.['pattern']">Ingresa un teléfono válido</p>

  <div class="ba-field-group">
    <ibk-input-group>
      <label>Email</label>
      <ibk-input class="field">
        <input class="field" formControlName="email" />
        <!-- [attr.disabled]="customer ? true : null"  -->
      </ibk-input>
    </ibk-input-group>
  </div>

  <h1 class="ibk-title">Dirección legal</h1>

  <ibk-input *ngIf="!isClient">
    <input type="checkbox" formControlName="isSameAddress" />
    La dirección de la empresa previamente declarada es la misma de mi domicilio.
  </ibk-input>

  <ng-container *ngIf="addressForm" [formGroup]="addressForm">
    <ba-address-form></ba-address-form>
  </ng-container>

  <ibk-button class="ba-action">
    <button
      (click)="done()"
      [disabled]="form.invalid"
      class="ibk-btn ibk-btn--min-width ibk-btn--primary ba-btn"
    >
      Continuar
    </button>
  </ibk-button>
</ng-template>

<ng-container *ngTemplateOutlet="content; context: { customer: (customer$ | async) || null }"></ng-container>
